import { useCallback } from 'react';
import { useAppUpdatesContext } from '@app/app/src/AppContext';

export const useBundlePagination = () => {
  const { dispatch } = useAppUpdatesContext();

  const setCursor = useCallback(
    (cursor: string | undefined) => {
      dispatch({
        type: 'BUNDLES_CURSOR_SET',
        payload: { cursor },
      });
    },
    [dispatch],
  );

  const setLimit = useCallback(
    (limit: number) => {
      dispatch({
        type: 'BUNDLES_LIMIT_SET',
        payload: { limit },
      });
    },
    [dispatch],
  );

  return { setCursor, setLimit };
};
